<template>
  <BlokkliProvider
    v-if="variation"
    v-bind="variation.blokkliProps"
    class="container grid-cols-1"
  >
    <PDPStage
      :tagline="$texts('strap', 'Strap')"
      :cta-button="variation.ctaType"
      :variation="variation"
    />
    <BlokkliField name="field_paragraphs" :list="paragraphs" />
    <PDPTeaserSlider
      :variations="matchingWatches"
      :title="$texts('matchingModels', 'Matching models')"
    />
    <RenderCacheable
      v-if="infoParagraphs"
      :cache-key="cacheKey"
      :max-age="60 * 60"
    >
      <PDPInfoGrid :paragraphs="infoParagraphs" />
    </RenderCacheable>
    <PDPCommerceInfo class="mt-[--paragraph-gap-desktop]" />
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { ProductVariationWatchTeaserFragment } from '#build/graphql-operations'

definePageMeta({
  name: 'product-detail-strap',
})

const { $texts } = useEasyTexts()

const route = useRoute()
const { variation, paragraphs } = await useProductRoute('strap', route)

const matchingWatches = computed(
  () =>
    variation.value?.matchingWatches?.filter(
      (v): v is ProductVariationWatchTeaserFragment =>
        '__typename' in v &&
        v.__typename === 'CommerceProductVariationWatchDefault',
    ) ?? [],
)

const { data: infoParagraphs } = await useAsyncData(() =>
  useCachedGraphqlQuery('infoParagraphsStrap').then(
    (v) => v.data.config?.paragraphs || [],
  ),
)

const cacheKey = useCacheKey('strap-info-grid')

const { trackProductView, trackPageView } = useAnalyticsTracking()
if (variation.value) {
  trackProductView(variation.value)
}
trackPageView()
</script>

<style lang="scss" scoped>
:deep(.paragraph),
.paragraph {
  &:first-of-type {
    @include pdp-first-paragraph-spacing;
  }

  @include paragraph-spacing;
}
</style>
